export type ThemeMode = 'light' | 'dark';

const KEY = 'evenhouse.theme';

/** Light is the default. We deliberately do not follow the OS setting. */
export function loadTheme(): ThemeMode {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function applyTheme(mode: ThemeMode) {
  const root = document.documentElement;
  if (mode === 'dark') root.setAttribute('data-theme', 'dark');
  else root.removeAttribute('data-theme');

  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', mode === 'dark' ? '#0C1411' : '#F1F4F0');

  try { localStorage.setItem(KEY, mode); } catch { /* private mode */ }
}
